import React, { useEffect } from 'react';
import './App.module.scss';
import BaseLayout from './components/BaseLayout';
import { BrowserRouter } from 'react-router-dom';
import { logGa } from './utils/log';

function App() {
  useEffect(() => {
    logGa('home_page_visit');
    console.log("vo home_page")
  }, []);

  return (  
    <div>
      <BrowserRouter>
        <BaseLayout />
      </BrowserRouter>
    </div>
  );
}

export default App;
